module.exports = __webpack_public_path__ + "static/media/youtube.ef86b6ab.svg";